import { render, staticRenderFns } from "./EleDetail.vue?vue&type=template&id=6ec1e00a&scoped=true"
import script from "./EleDetail.vue?vue&type=script&lang=js"
export * from "./EleDetail.vue?vue&type=script&lang=js"
import style0 from "./EleDetail.vue?vue&type=style&index=0&id=6ec1e00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1e00a",
  null
  
)

export default component.exports